<template>
    <el-dialog :title="title" :visible="showflag" :width="width" @close="closeDialog">
        <el-form ref="formValidate" :model="model" :rules="rules" label-width="120px">
            <el-form-item label="通知类型：" prop="notice_type">
                <el-input v-model="model.notice_type"></el-input>
            </el-form-item>
            <el-form-item label="会员ID：" prop="member_id">
                <el-input v-model="model.member_id"></el-input>
            </el-form-item>
            <el-form-item label="车辆表ID：" prop="car_info_id">
                <el-input v-model="model.car_info_id"></el-input>
            </el-form-item>
            <el-form-item label="CarId：" prop="car_id">
                <el-input v-model="model.car_id"></el-input>
            </el-form-item>
            <el-form-item label="VehicleId：" prop="vehicle_id">
                <el-input v-model="model.vehicle_id"></el-input>
            </el-form-item>
            <el-form-item label="标记：" prop="sign">
                <el-input v-model="model.sign"></el-input>
            </el-form-item>
            <el-form-item label="first：" prop="first">
                <el-input v-model="model.first"></el-input>
            </el-form-item>
            <el-form-item label="keyword1：" prop="keyword1">
                <el-input v-model="model.keyword1"></el-input>
            </el-form-item>
            <el-form-item label="keyword2：" prop="keyword2">
                <el-input v-model="model.keyword2"></el-input>
            </el-form-item>
            <el-form-item label="keyword3：" prop="keyword3">
                <el-input v-model="model.keyword3"></el-input>
            </el-form-item>
            <el-form-item label="keyword4：" prop="keyword4">
                <el-input v-model="model.keyword4"></el-input>
            </el-form-item>
            <el-form-item label="remark：" prop="remark">
                <el-input v-model="model.remark"></el-input>
            </el-form-item>
            <el-form-item label="发生时间：" prop="send_time">
                <el-input v-model="model.send_time"></el-input>
            </el-form-item>
            <el-form-item label="是否已读：" prop="is_read">
                <el-input v-model="model.is_read"></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="closeDialog" size="medium">取 消</el-button>
            <el-button type="primary" @click="handleSubmit" size="medium">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
import editutil from '@/libs/editutil'
import { saveModel } from '@/api/common'

export default {
    name: 'noticeEdit',
    mixins: [editutil],
    data() {
        return {
            model: {
                notice_type: '',
                member_id: '',
                car_info_id: '',
                car_id: '',
                vehicle_id: '',
                sign: '',
                first: '',
                keyword1: '',
                keyword2: '',
                keyword3: '',
                keyword4: '',
                remark: '',
                send_time: '',
                is_read: '',
            },
            getObj:{
                url:'/api/admin/notice/info',
                data:{
                    key:'id',
                    value:''
                }
            },
            enu_name: [],
            rules: {
                xxxname: [
                    {required: true, message: 'xxx名称不能为空', trigger: 'blur'}
                ],
            }
        };
    },
    methods: {
        //保存方法
        handleSubmit() {
            this.$refs[this.form_name].validate((valid) => {
                if (valid) {
                    this.formatModel();
                    let config = {
                        url:'/api/admin/notice/save'
                    }
                    config["data"] = this.model;
                    saveModel(config).then(res=>{
                        if(res.code===1){
                            this.$msgs("保存成功！");
                            this.$emit("on-save-ok",{});
                        }else{
                            this.$msg(res.msg)
                        }
                    }).catch();
                }
            })
        },
    }
};
</script>